import { CloseIcon, HamburgerIcon } from '@chakra-ui/icons';
import React, { useState } from 'react';

import { IconButton } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import Logo from '../../../assets/images/logo.png';

const HeaderNavMenu = () => {
  const [isMobileMenuOpen, setMenuOpen] = useState(false);
  return (
    <>
      <header className='flex items-center justify-between sm:justify-start gap-4 md:gap-10 z-20'>
        <Link to='/'>
          <img src={Logo} alt='Logo' width={98} />
        </Link>
        <nav>
          <IconButton
            color='white'
            backgroundColor='#1CA5CC'
            onClick={() => setMenuOpen(!isMobileMenuOpen)}
            aria-label='Navigation'
            icon={isMobileMenuOpen ? <CloseIcon /> : <HamburgerIcon />}
            className='sm:!hidden md:!hidden lg:!hidden xl:!hidden 2x:!hidden hover:!bg-[#60c0db]'
          />
          <ul
            className={`absolute inset-x-0 py-4 bg-white w-full flex flex-col text-sm font-semibold z-10 ${
              isMobileMenuOpen ? 'flex' : '!hidden'
            }`}
          >
            <Link className='py-2 px-5 hover:bg-[#F6EDF4]' to='#whatIsOti'>
              ¿Qué es OTI?
            </Link>
            <Link className='py-2 px-5 hover:bg-[#F6EDF4]' to='#methodology'>
              ¿Cómo funciona?
            </Link>
            <Link className='py-2 px-5 hover:bg-[#F6EDF4]' to='#privacy'>
              Privacidad
            </Link>
            <Link className='py-2 px-5 hover:bg-[#F6EDF4]' to='#faq'>
              Preguntas frecuentes
            </Link>
          </ul>

          <ul className='sm:!flex gap-6 !hidden text-sm font-semibold z-10'>
            <Link to='#whatIsOti'>¿Qué es OTI?</Link>
            <Link to='#methodology'>¿Cómo funciona?</Link>
            <Link to='#privacy'>Privacidad</Link>
            <Link to='#faq'>Preguntas frecuentes</Link>
          </ul>
        </nav>
      </header>
    </>
  );
};

export default HeaderNavMenu;
